import * as scheduleActions from '../actions/schedules'

const initialState = {
  isDownloading: false,
}

const schedules = (state =initialState, action) => {
  switch (action.type) {
  case scheduleActions.GET_SCHEDULES_STARTED:
    return {
      ...state,
      isDownloading: true
    }
  case scheduleActions.GET_SCHEDULES_SUCCEEDED:
  case scheduleActions.GET_SCHEDULES_FAILED:
    return {
      ...state,
      isDownloading: false
    }
  default:
    return state
  }
}

export default schedules



// WEBPACK FOOTER //
// ./src/reducers/schedules.js